import classNames from 'classnames';
import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';

const styles = require('./Question.module.css');

const defaultQuestion = 'How does your child get answers?';

const defaultOptions = [
  "When there's a hands-on activity",
  'When they get to use their imagination',
  'When they get to ask "why?" and dig for answers',
  'When they get to work with a team towards a shared goal',
];

function Question({
  selectedOption,
  onSelectOption,
  question = defaultQuestion,
  options = defaultOptions,
}) {
  return (
    <div className={styles.quizQuestionContainer}>
      <CodeSparkThemedTypography variant="h4">{question}</CodeSparkThemedTypography>

      <div className={styles.quizQuestionOptions}>
        {options.map((option, i) => {
          return (
            <button
              key={`quiz_question_option_${i}`}
              className={classNames(styles.quizQuestionOptionsItem, {
                [styles.selected]: selectedOption === i,
              })}
              onClick={() => onSelectOption(i)}
            >
              <CodeSparkThemedTypography variant="body1" Element="span">
                {option}
              </CodeSparkThemedTypography>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default Question;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Quiz/Question.js